module.exports = new (require('fragment-cache'))();



//////////////////
// WEBPACK FOOTER
// ./node_modules/nanomatch/lib/cache.js
// module id = wMFu
// module chunks = 0